export class BaseService {

    constructor($http) {
        this.$http = $http;
    }

    getRoot() {
        return '/api';
    }
}



// WEBPACK FOOTER //
// ./src/app/services/baseService.js